import { IModel, IAttribute, Collection } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { NativeMongoDbDataset } from 'app/model/dataset/native-mongo-db.dataset';
import { CopySource } from 'app/model/pipeline/copysource/copysource';

import { ParameterConfig } from 'app/model/pipeline/parameter-config';
import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';

@Metamodel.model({
    name: 'MongoDbV2Source',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(NativeMongoDbDataset) }
})
export class NativeMongoDbCopySource extends CopySource {
    public static readonly MODEL: IModel;
    public static readonly BATCH_SIZE: IAttribute;
    public static readonly FILTER: IAttribute;
    public static readonly PROJECT: IAttribute;
    public static readonly CURSORMETHODS: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'BATCH_SIZE',

        display: stringResources.ModelName_BatchSize
    })
    public batchSize?: number = 100;

    @Metamodel.attribute({
        templatable: true,
        association: 'FILTER',

        display: stringResources.Filter
    })
    public filter?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CursorMethods,
        collection: Collection.Array,

        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public cursorMethods?: ParameterConfig[] = [];

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
